window.compressImage = async (byteArray, fileName, inputFormat = "image/jpeg", outputFormat = "image/webp", quality = 0.7, maxWidth = 1200) => {
    return new Promise((resolve, reject) => {
        const blob = new Blob([byteArray], { type: inputFormat }); 

        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function (event) {
            const img = new Image();
            img.src = event.target.result;
            img.onload = function () {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                const scaleSize = maxWidth / img.width;
                canvas.width = maxWidth;
                canvas.height = img.height * scaleSize;

                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                canvas.toBlob((compressedBlob) => {
                    if (compressedBlob) {
                        compressedBlob.arrayBuffer().then(buffer => {
                            resolve(new Uint8Array(buffer));
                        });
                    } else {
                        reject(new Error("Compression failed."));
                    }
                }, outputFormat, quality);
            };
        };
        reader.onerror = (error) => reject(error);
    });
};
